/**
 * API client selector - exports either real API client or mock API client
 * based on configuration.
 */

import config from '../config/config';
import realApiClient from './realApi';
import mockApiClient from './mockApi';

// Export the appropriate API client based on configuration
const apiClient = config.features.useMockApi ? mockApiClient : realApiClient;

// Log which client is being used
if (config.features.useMockApi) {
  console.log('🎭 Using Mock API Client for development');
} else {
  console.log('🌐 Using Real API Client:', config.apiUrl);
}

export default apiClient;
